
<div >
  @if (tenantShopList.length > 1) {
    <div class="py-3 d-flex flex-row">
      @for (tenantShop of tenantShopList; track tenantShop) {
        <div class="d-flex ms-2" (click)="setActive(tenantShop.Id)">
          <button class="m-0 btn btn-small" [class.btn-primary]="activeTenantShop.Id == tenantShop.Id">{{tenantShop.Name}}</button>
        </div>
      }
    </div>
  }

  <t4-list-view #crossSellProductEventListVw [options]="pptEventEditListOptions" (onDataRequest)="onDataRequest($event)">

    <ng-container *t4ListActions>
      @if (!isInArchiveMode) {
        <button (click)="actionClick('add')"  class="btn btn-primary border" type="button"><i class="far fa-plus-square"></i>{{ 'GENERIC.BUTTON.ADDNEW' | translate}}</button>
      }
    </ng-container>


    <ng-container *t4ListItem="let item">

      <th scope="row" >
        <button (click)="reOrder('up', item.GroupingId)" [disabled]="item.SortOrder === 1" type="button" class="btn btn-grid btn-round mdi mdi-primary mdi-arrow-up-bold-circle-outline"></button>
        <button (click)="reOrder('down', item.GroupingId)" [disabled]="+item.SortOrder === +totalObjectCount" type="button" class="btn btn-grid btn-round mdi mdi-primary mdi-arrow-down-bold-circle-outline"></button>
      </th>

      <td >{{item.ProductName | translate}}</td>
      <td >{{item.VariantNames}}</td>
      <td >{{item.OnSaleFrom | localDateTime}}</td>
      <td >{{item.OnSaleTill | localDateTime}}</td>


      <td class="grid-action" >
        @if (!isInArchiveMode) {
          <button (click)="actionClick('edit', item)" type="button" class="btn btn-grid btn-round mdi mdi-info mdi-lead-pencil"></button>
        }
        @if (!isInArchiveMode) {
          <button (click)="actionClick('delete', item)" type="button" class="btn btn-grid btn-round mdi mdi-danger mdi-trash-can-outline"></button>
        }
      </td>

    </ng-container>

  </t4-list-view>

  <div>